<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="dark">
        <ion-title>Product Details</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-card>
        <ion-row class="title">
          <ion-col size-md="6" size-xs="12">
            <ion-img :src="productDetail.data.photo" alt="detail-product" size-md="3" />
          </ion-col>
          <ion-col size-md="6" size-xs="12">
            <h6>{{ productDetail.data.name }}</h6>
            <p>{{ productDetail.data.description }}</p>
            <h6>Tersedia di Outlet</h6>
            <ion-list>
              <ion-item v-for="(product, index) in productDetail.data.available" :key="index">
                <ion-label>
                  <h2 :class="product.stock_status == 'available' ? '' : 'disabled'
                    ">
                    {{ product.name }}
                  </h2>
                  <h3 :class="product.stock_status == 'available' ? '' : 'disabled'
                    ">
                    {{ formatter.format(product.price_sell) }}
                  </h3>
                </ion-label>
                <ion-button slot="end" v-if="product.stock_status == 'available'" color="danger" @click="
                  addOrder(
                    {
                      product_name: productDetail.data.name,
                      note: '',
                      price: parseInt(product.price_sell),
                      product_detail_id: parseInt(product.product_detail_id),
                      product_id: productDetail.data.product_id,
                      photo: productDetail.data.photo,
                      qty: 1,
                      tax: product.tax,
                    },
                    product
                  )
                  ">
                  <!-- <router-link
                    class="link"
                    :to="{ name: 'home', params: { id: outletId } }"
                  >
                  </router-link> -->
                  Order
                </ion-button>
                <p class="unavailable" slot="end" v-if="product.stock_status == 'unavailable'">
                  Run out off stock
                </p>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>
      </ion-card>
    </ion-content>
    <ion-footer>
      <ion-toolbar color="dark">
        <ion-title>Powered By <span>UNIQ</span></ion-title>
      </ion-toolbar>
    </ion-footer>
  </div>
</template>

<script>
import { IonButton, IonCard, IonCol, IonContent, IonFooter, IonHeader, IonImg, IonItem, IonLabel, IonList, IonRow, IonTitle, IonToolbar } from '@ionic/vue';
import { storage } from '../utils/storage';

// import axios from 'axios';

export default {
  name: "detailProduct",
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonCard, IonRow, IonCol, IonImg, IonList, IonItem, IonLabel, IonButton, IonFooter },
  data() {
    return {
      formatter: new Intl.NumberFormat("ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 2,
      }),
      productDetail: null,
    };
  },
  async created() {
    let getProduct = async () => {
      let detailId = parseInt(this.$route.params.detail_id);
      let url = `${process.env.VUE_APP_BASE_URL}v1/product/availability/detail/${detailId}?include=tax`;
      let myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}`);

      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const req = await fetch(url, requestOptions);
      this.productDetail = await req.json();
      console.log(this.productDetail);
    };
    getProduct();
  },
  methods: {
    addOrder(data, product) {
      const outlet_id = this.$route.params.id;
      const lastOrder = storage.getLastOrder();

      data.tax.map((d) => {
        if (d.tax_status == "permanent") {
          return { ...data, tax: d };
        }
      });

      let arrOrder;
      if (lastOrder != null) {
        if (outlet_id == lastOrder.outlet_id) {
          arrOrder = lastOrder.products;
        }

        let check = arrOrder.find(
          (item) => item.product_id === data.product_id
        );

        if (check === undefined) {
          arrOrder.push(data);
          storage.setLastOrder(JSON.stringify({ outlet_id, products: arrOrder }))
        } else {
          arrOrder = [
            { ...data, qty: 1, price: data.price_after_tax }
          ];
          storage.setLastOrder(JSON.stringify({ outlet_id, products: arrOrder }))
        }
      } else {
        arrOrder = [];
        arrOrder.push(data);
        storage.setLastOrder(JSON.stringify({ outlet_id, products: arrOrder }))
      }

      window.location.replace("/" + parseInt(product.outlet_id));
    },
  },
};
</script>

<style scoped>
span {
  color: #f05e23;
}

ion-header {
  text-align: center;
}

ion-footer {
  text-align: center;
}

img {
  margin-top: 14px;
  margin-bottom: 14px;
  border-radius: 7px;
}

/* media query */
@media screen and (max-width: 600px) {
  img {
    height: 200px;
    object-fit: cover;
  }
}

ion-col {
  padding: 0 14px;
}

ion-col h6 {
  color: #333;
  font-weight: bold;
}

.unavailable {
  color: crimson;
  font-weight: bold;
}

.disabled {
  color: #737373;
}

ion-label h2 {
  color: #333;
}

ion-label h3 {
  color: #333;
}

.link {
  text-decoration: none;
  color: #222428;
  font-weight: bold;
}
</style>
